import { render, staticRenderFns } from "./SampleTablePage.vue?vue&type=template&id=46a118ae&scoped=true&"
import script from "./SampleTablePage.vue?vue&type=script&lang=js&"
export * from "./SampleTablePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a118ae",
  null
  
)

export default component.exports